var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFindProspect = function SvgFindProspect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9444 36.8889C28.8549 36.8889 36.8889 28.8549 36.8889 18.9444C36.8889 9.034 28.8549 1 18.9444 1C9.034 1 1 9.034 1 18.9444C1 28.8549 9.034 36.8889 18.9444 36.8889Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 39L31.6113 31.6111M36.8889 18.9444C36.8889 28.8549 28.8549 36.8889 18.9444 36.8889C9.034 36.8889 1 28.8549 1 18.9444C1 9.034 9.034 1 18.9444 1C28.8549 1 36.8889 9.034 36.8889 18.9444Z",
    stroke: "#3953FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21C16.3448 21 13.9835 22.2755 12.4802 24.255C12.1566 24.681 11.9948 24.894 12.0001 25.1819C12.0042 25.4043 12.1446 25.6849 12.3205 25.8222C12.5482 26 12.8637 26 13.4947 26H24.5053C25.1363 26 25.4518 26 25.6795 25.8222C25.8554 25.6849 25.9958 25.4043 25.9999 25.1819C26.0052 24.894 25.8434 24.681 25.5198 24.255C24.0165 22.2755 21.6552 21 19 21Z",
    fill: "#3953FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.5C21.0817 18.5 22.7692 16.8211 22.7692 14.75C22.7692 12.6789 21.0817 11 19 11C16.9183 11 15.2308 12.6789 15.2308 14.75C15.2308 16.8211 16.9183 18.5 19 18.5Z",
    fill: "#3953FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21C16.3448 21 13.9835 22.2755 12.4802 24.255C12.1566 24.681 11.9948 24.894 12.0001 25.1819C12.0042 25.4043 12.1446 25.6849 12.3205 25.8222C12.5482 26 12.8637 26 13.4947 26H24.5053C25.1363 26 25.4518 26 25.6795 25.8222C25.8554 25.6849 25.9958 25.4043 25.9999 25.1819C26.0052 24.894 25.8434 24.681 25.5198 24.255C24.0165 22.2755 21.6552 21 19 21Z",
    stroke: "#3953FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.5C21.0817 18.5 22.7692 16.8211 22.7692 14.75C22.7692 12.6789 21.0817 11 19 11C16.9183 11 15.2308 12.6789 15.2308 14.75C15.2308 16.8211 16.9183 18.5 19 18.5Z",
    stroke: "#3953FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFindProspect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/findProspect.de3cd843.svg";
export { ForwardRef as ReactComponent };